module.exports = __webpack_public_path__ + "img/github-logo.4cad0035.svg";